import gql from 'graphql-tag';
import { kmsClient } from '../../../apollo';
import { useMutation } from '@apollo/react-hooks';
import {
  UpdateGoogleCampaignsStatus,
  UpdateGoogleCampaignsStatusVariables
} from './__generated__/UpdateGoogleCampaignsStatus';

const UPDATE_GOOGLE_CAMPAIGNS_STATUS_MUTATION = gql`
  mutation UpdateGoogleCampaignsStatus($articleIds: [ID!]!, $status: GoogleStatusEnum!) {
    updateGoogleCampaignsStatus(articleIds: $articleIds, status: $status) {
      articles {
        id
        googleStatus
      }
      errors
    }
  }
`;

export const useUpdateGoogleCampaignsStatus = () => {
  return useMutation<UpdateGoogleCampaignsStatus, UpdateGoogleCampaignsStatusVariables>(
    UPDATE_GOOGLE_CAMPAIGNS_STATUS_MUTATION,
    { client: kmsClient }
  );
};
